import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BrandTermsPage = loadAsyncComponent(() => import('./Container'), 'page');
